import {
    actionTypes as asyncTypes,
    isAsyncComplete,
} from "async-ops";
import { cloneDeep } from "lodash";
import { isMdaeWidgetOptionChangeEvent, updateStateAfterWidgetOptionChange } from "../../../mdae-framework";
import { GET_NOTIFICATIONS } from "../services/get-notifications";
import { GET_SYSTEM_MESSAGES } from "../services/get-system-messages";
import { UPDATE_SYSTEM_MESSAGE } from "../services/update-system-message";
import { ADD_SYSTEM_MESSAGE } from "../services/add-system-message";
import { categories, NOTIFICATION_AND_SYSTEM_MODULE_STATES } from "../constants";
export const defaultNotificationgridSelectionObject = {
    mode: "single",
    allowSelectAll: true,
    selectAllMode: "allPages",
    showCheckBoxesMode: "always",
}
export const TOGGLE_NOTIFICATION_PANEL = 'TOGGLE_NOTIFICATION_PANEL';
export const TOGGLE_NOTIFICATION_GRID_SELECTION = 'TOGGLE_NOTIFICATION_GRID_SELECTION';
export const TOGGLE_DELETE_NOTIFICATION_BUTTON = 'TOGGLE_DELETE_NOTIFICATION_BUTTON';
export const SET_NOTIFICATION_GRID_SELECTED_ROW_KEYS = 'SET_NOTIFICATION_GRID_SELECTED_ROW_KEYS';
export const TOGGLE_NOTIFICATION_AREA_TYPE_FILTER_POPOVER = 'TOGGLE_NOTIFICATION_AREA_TYPE_FILTER_POPOVER';
export const TOGGLE_NOTIFICATION_AND_SYSTEM_MSG_GRID_SEARCH_PANEL = 'TOGGLE_NOTIFICATION_AND_SYSTEM_MSG_GRID_SEARCH_PANEL';
export const SET_NOTIFICATION_DATA_GRID_FILTER = 'SET_NOTIFICATION_DATA_GRID_FILTER';
export const SET_AREA_TYPE_FILTER_LIST_CHECKBOXES = 'SET_AREA_TYPE_FILTER_LIST_CHECKBOXES';
export const TOGGLE_SYSTEM_MESSAGES_LIST_ACTION_POPOVER = 'TOGGLE_SYSTEM_MESSAGES_LIST_ACTION_POPOVER';
export const SET_SYSTEM_MESSAGES = 'SET_SYSTEM_MESSAGES';
export const SET_ADD_SYSTEM_MESSAGE_POPUP_DATA = 'SET_ADD_SYSTEM_MESSAGE_POPUP_DATA';
export const RESET_ADD_SYSTEM_MESSAGE_POPUP_VALIDATION = 'RESET_ADD_SYSTEM_MESSAGE_POPUP_VALIDATION';
export const TOGGLE_ADD_SYSTEM_MESSAGE_POPUP = 'TOGGLE_ADD_SYSTEM_MESSAGE_POPUP';
export const TOGGLE_SYSTEM_NOTICE_POPUP = 'TOGGLE_SYSTEM_NOTICE_POPUP';
export const SELECT_ALL_CLIENTS = 'SELECT_ALL_CLIENTS';
export const RESET_ADD_MESSAGES_POPUP_VALIDATION = 'RESET_ADD_MESSAGES_POPUP_VALIDATION';
export const SET_NOTIFICATION_AS_READ = 'SET_NOTIFICATION_AS_READ';
export const UPDATE_NOTIFICATION_LIST = 'UPDATE_NOTIFICATION_LIST';
export const SET_CURRENT_SELECTED_MODULE = 'SET_CURRENT_SELECTED_MODULE';
export const initialSystemMessagePopupFormData = {
    category: categories[0],
    publishDate: null,
    unpublishDate: null,
    showAsPopup: true,
    popupText: "",
    longText: "",
    emailText: "",
    clientIds: [],
}
const initialState = {
    isLoading: false,
    isNotificationPanelOpen: false,
    notificationGridSelectionObject: {...defaultNotificationgridSelectionObject},
    isDeleteNotificationBtnVisible: false,
    notificationGridSelectedRowKeys: [],
    isNotificationAndSystemMessagesGridSearchPanelVisible: false,
    notificationsAreaTypeFilterItems: [],
    notificationsDataGridFilter: [],
    notificationList: [],
    systemMessageList: [],
    clientList: [],
    isAuthorized: false,
    systemMessagePopupFormData: initialSystemMessagePopupFormData,
    refreshSystemMessagesGrid: false,
    currentSelectedModule: NOTIFICATION_AND_SYSTEM_MODULE_STATES.NOTIFICATION_MODULE
};
export default function (state = initialState, action) {
    let newState;
    switch (action.type) {
        case TOGGLE_NOTIFICATION_PANEL:
        case TOGGLE_NOTIFICATION_GRID_SELECTION:
        case TOGGLE_DELETE_NOTIFICATION_BUTTON:
        case SET_NOTIFICATION_GRID_SELECTED_ROW_KEYS:
        case TOGGLE_NOTIFICATION_AREA_TYPE_FILTER_POPOVER:
        case TOGGLE_NOTIFICATION_AND_SYSTEM_MSG_GRID_SEARCH_PANEL:
        case SET_NOTIFICATION_DATA_GRID_FILTER:
        case SET_AREA_TYPE_FILTER_LIST_CHECKBOXES:
        case TOGGLE_SYSTEM_MESSAGES_LIST_ACTION_POPOVER:
        case SET_ADD_SYSTEM_MESSAGE_POPUP_DATA:
        case SET_SYSTEM_MESSAGES:
        case RESET_ADD_SYSTEM_MESSAGE_POPUP_VALIDATION:
        case TOGGLE_ADD_SYSTEM_MESSAGE_POPUP:
        case RESET_ADD_MESSAGES_POPUP_VALIDATION:
        case SET_CURRENT_SELECTED_MODULE:
            newState = {...state};
            if (isMdaeWidgetOptionChangeEvent(action.data)) {
                newState = updateStateAfterWidgetOptionChange(newState, action.data);
            } else {
                newState = { ...newState, ...action.data };
            }
            return newState;
        case TOGGLE_SYSTEM_NOTICE_POPUP:
            newState = {...state};
            if (isMdaeWidgetOptionChangeEvent(action.data)) {
                newState = updateStateAfterWidgetOptionChange(newState, action.data);
            } else {
                const noticePopupConfig = newState.noticePopupConfig
                    ? newState.noticePopupConfig
                    : {};
                for (let prop in action.data) {
                    noticePopupConfig[prop] = action.data[prop];
                }
                newState = {
                    ...newState,
                    noticePopupConfig: noticePopupConfig,
                };
            }
            return newState;
        case SELECT_ALL_CLIENTS:
            newState = {...state};
            newState = {
                ...newState,
                systemMessagePopupFormData: {
                    ...newState.systemMessagePopupFormData,
                    clientIds: action.data
                }
            }
            return newState;
        case SET_NOTIFICATION_AS_READ:
            newState = {...state};
            const notificationIndex = newState.notificationList.findIndex(
                (x) => x.notificationId === action.notificationId
            );
            newState = {
                ...newState,
                notificationList: [
                    ...newState.notificationList.slice(0, notificationIndex),
                    { ...newState.notificationList[notificationIndex], isNotificationRead: true },
                    ...newState.notificationList.slice(notificationIndex + 1),
                ],
            }
            return newState;
        case UPDATE_NOTIFICATION_LIST:
            newState = {...state};
            const notificationList: any[] = action.data?.notificationList;
            const deleteNotificationIds: any[] = action.data?.deleteNotificationIds;
            if (notificationList?.length > 0)
                for (const notification of notificationList) {
                    const notificationIndex = newState.notificationList.findIndex(
                        (x) => x.notificationId === notification.notificationId
                    );
                    if (notificationIndex !== -1) {
                        if (deleteNotificationIds?.includes(notification.notificationId)) {
                            //deleted - if index found and notification is deleted remove notification from list
                            newState = {
                                ...newState,
                                notificationList: [
                                    ...newState.notificationList.slice(0, notificationIndex),
                                    ...newState.notificationList.slice(notificationIndex + 1),
                                ],
                            }
                        } else {
                            //updated - if index found replace notification at index
                            newState = {
                                ...newState,
                                notificationList: [
                                    ...newState.notificationList.slice(0, notificationIndex),
                                    { ...notification },
                                    ...newState.notificationList.slice(notificationIndex + 1),
                                ],
                            }
                        }

                    } else if (notificationIndex === -1) {
                        //added - if index not found add notification at first place
                        newState = {
                            ...newState,
                            notificationList: [
                                { ...notification },
                                ...newState.notificationList,
                            ],
                        }
                    }
                }
            return newState;
        case asyncTypes.OPERATION:
        case asyncTypes.COMPLETE:
        case asyncTypes.FAILURE:
            if (isAsyncComplete(GET_NOTIFICATIONS)(action)) {               
                return { ...state, notificationList: action.response, loading: false };
            }
            if (isAsyncComplete(GET_SYSTEM_MESSAGES)(action)) {
                return {
                    ...state, systemMessageList: action.response?.messages,
                    clientList: action.response?.clientList,
                    isAuthorized: action.response?.isAuthorized,
                    refreshSystemMessagesGrid: false, loading: false
                };
            }
            if (isAsyncComplete(UPDATE_SYSTEM_MESSAGE)(action) ||
                isAsyncComplete(ADD_SYSTEM_MESSAGE)(action)) {
                return { ...state, refreshSystemMessagesGrid: true, loading: false };
            }
            return state;
        default:
            return state;
    }
}

export const formatSystemMessagePopupFormDataToInsert = (formData) => {
    if (formData) {
        if (formData.emailText) {
            formData.sendAsEmail = true;
        }
        else {
            formData.sendAsEmail = false;
        }

        if (formData.longText) {
            formData.showOnLoginScreen = true;
        }
        else {
            formData.showOnLoginScreen = false;
        }
        formData.clients = "";
        const clientIds = formData?.clientIds;
        for (const clientId of clientIds) {
            formData.clients += (clientId + ",");
        }
        formData.status = 'Active';
        formData.sticky = false;
    }
    return formData;
}